export const TWA_DOWNLOAD_SRC =
  (import.meta.env.VITE_TWA_DOWNLOAD_SRC as string | undefined) || ''

export const FRONT_HOST =
  (import.meta.env.VITE_FRONT_HOST as string | undefined) || ''
